import React from "react";
import AsyncImage from "@appComponents/AsyncImage/AsyncImage";
import SecondaryMarketService from "@services/SecondaryMarket.service";
import CurrencyElement from "@appComponents/CurrencyElement/CurrencyElement";
import { MyLink } from "@features/utils/reactFunctions";
import { ISPVsListRow, TAssetsListRowState } from "./ISPVsList";
import Loader from "@appComponents/Loader/Loader";
import { MAIN_CURRENCY } from "@bundles/consts";
import noPhotoCompany from "@images/no_photo_company.png";

import * as style from "./SPVsListStyle.module.scss";
import * as elements from "@appStyles/_elements.module.scss";
import SmallPriceChart from "@appComponents/SmallPriceChart/SmallPriceChart";

export class SPVsListRow extends React.Component<
  ISPVsListRow,
  TAssetsListRowState
> {
  constructor(props: ISPVsListRow) {
    super(props);

    this.state = {
      loader: true,
      tradesList: this.getTradesList(),
    };
  }

  getTradesList = () => {
    // TODO: handle error
    SecondaryMarketService.getPublicTradesHistory(
      this.props.spv.trading_asset_id
    ).then((resp) => {
      this.setState({
        loader: false,
        tradesList: resp.data,
      });
    });

    return undefined;
  };

  lastPrice = (lastPrice: number) => {
    return (
      lastPrice !== 0 &&
      lastPrice !== null && (
        <CurrencyElement value={lastPrice} currency={MAIN_CURRENCY} />
      )
    );
  };

  render() {
    const { spv } = this.props;
    const orderPageRoute = `/companies/${spv.company_slug}/market/spvs/${spv.id}/orders`;

    return (
      <div key={spv.id} className={elements.tableRow}>
        <div
          className={[
            elements.tableItem,
            style.companyLogo,
            style.spvsItem,
          ].join(" ")}
        >
          <AsyncImage image={spv.company_avatar.url} fallback={noPhotoCompany}>
            <img alt="logo" className={style.logo} />
          </AsyncImage>
          <div className={style.mobileName}>{spv.name}</div>
        </div>
        <div
          className={[elements.tableItem, style.spvsItem, style.spvName].join(
            " "
          )}
        >
          {this.props.userSignedIn ? (
            <MyLink to={orderPageRoute} isReactLink={false}>
              {spv.name}
            </MyLink>
          ) : (
            <span>{spv.name}</span>
          )}
        </div>
        <div className={[elements.tableItem, style.spvsItem].join(" ")}>
          <span className={elements.tableLabel}>Company Name</span>
          <a href={`/companies/${spv.company_slug}`}> {spv.company_name}</a>
        </div>
        <div className={[elements.tableItem, style.spvsItem].join(" ")}>
          <span className={elements.tableLabel}>Last Price</span>
          {this.lastPrice(spv.last_trade_price) || "-"}
        </div>
        <div className={[elements.tableItem, style.spvsItem].join(" ")}>
          {this.state.loader ? (
            <Loader small={true} />
          ) : (
            <SmallPriceChart
              assetId={spv.id}
              tradesList={this.state.tradesList || []}
              hidePercentage={true}
              color={"#81109c"}
              width={100}
              height={27}
            />
          )}
        </div>
        <div className={[elements.tableItem, style.buyContainer].join(" ")}>
          {this.props.userSignedIn ? (
            <MyLink
              className={[
                elements.btn,
                elements.btnSuccess,
                style.tradeBtn,
              ].join(" ")}
              to={orderPageRoute}
              isReactLink={false}
              data-cy={`trade-${spv.id}`}
            >
              Trade
            </MyLink>
          ) : (
            <MyLink
              className={[
                elements.btn,
                elements.btnSuccess,
                style.tradeBtn,
              ].join(" ")}
              to={`/users/sign_in?return_url=${orderPageRoute}`}
              data-cy={`trade-${spv.id}`}
            >
              Trade
            </MyLink>
          )}
        </div>
      </div>
    );
  }
}
